<template>
  <v-container v-if="filter.type === 'date'">
    <div class="pa-2">
      <div class="d-flex">
        <div>
          <v-select
            dense
            class="mr-2"
            style="max-width: 10.625em"
            :menu-props="{ bottom: true, offsetY: true }"
            :items="filter.dropDownItems"
            item-text="name"
            v-model="filter.dropDownModel"
            label="Variation"
            hide-details
            outlined
            return-object
            @input="resetAllDateModals"
          ></v-select>
        </div>
        <div
          class="mr-2 date-from"
          v-if="
            filter.dropDownModel.id === 'isOn' ||
            filter.dropDownModel.id === 'isAfter' ||
            filter.dropDownModel.id === 'isInTheRange'
          "
        >
          <v-menu
            v-model="filter.dateFromMenuModel"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filter.dateFrom"
                label=""
                prepend-inner-icon="fa-light fa-calendar"
                outlined
                dense
                hide-details
                v-bind="attrs"
                v-on="on"
                class="black--text"
                @keypress="filterNumbers(event)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filter.dateFrom"
              @input="filter.dateFromMenuModel = false"
            ></v-date-picker>
          </v-menu>
        </div>
        <div
          v-if="filter.dropDownModel.id === 'isInTheRange'"
          class="d-flex align-center mr-2"
        >
          and
        </div>
        <div
          class="black--text"
          style="width: 9.375em"
          v-if="
            filter.dropDownModel.id === 'isBefore' ||
            filter.dropDownModel.id === 'isInTheRange'
          "
        >
          <v-menu
            v-model="filter.dateToMenuModel"
            :close-on-content-click="false"
            :nudge-left="120"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filter.dateTo"
                label=""
                prepend-inner-icon="fa-light fa-calendar"
                outlined
                dense
                hide-details
                v-bind="attrs"
                v-on="on"
                class="black--text"
                @keypress="filterNumbers(event)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filter.dateTo"
              @input="filter.dateToMenuModel = false"
            ></v-date-picker>
          </v-menu>
        </div>
        <div v-if="filter.dropDownModel.id === 'isWithin'" class="d-flex">
          <div style="width: 8.75em">
            <v-select
              dense
              class="mr-2 black--text"
              :menu-props="{ bottom: true, offsetY: true }"
              :items="lastUpcomingItems"
              v-model="lastUpcomingModel"
              label="Variation"
              hide-details
              outlined
            ></v-select>
          </div>
          <div style="width: 4.375em" class="mr-2">
            <v-text-field
              type="number"
              min="1"
              dense
              outlined
              hide-details
              v-model="isWithinNumberModel"
              class="black--text"
              @keypress="filterNumbers(event)"
            ></v-text-field>
          </div>
          <div style="width: 8.125em">
            <v-select
              dense
              class="mr-2"
              :menu-props="{ bottom: true, offsetY: true }"
              :items="calendricalItems"
              v-model="calendricalModel"
              label="Variation"
              hide-details
              outlined
            ></v-select>
          </div>
        </div>
      </div>
      <v-row justify="end" class="mt-8">
        <v-btn
          color="#006CA1"
          depressed
          outlined
          small
          class="mr-2"
          @click="clearDates()"
        >
          Reset
        </v-btn>
        <v-btn color="#006CA1" dark depressed small @click="setFilters_emit()"
          >Set
        </v-btn>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Moment from "moment";
export default {
  props: ["filter"],
  name: "certificate-filters-dates",
  data() {
    return {
      lastUpcomingModel: "last",
      lastUpcomingItems: ["last", "upcoming"],
      calendricalModel: "days",
      calendricalItems: ["minutes", "days", "weeks", "months", "years"],
      isWithinNumberModel: 10,
      event: "",
    };
  },
  methods: {
    filterNumbers: function (evt) {
      evt = evt ? evt : window.event;

      if (evt.key === "Backspace") {
        return true;
      }

      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^\d{0,4}(-\d{0,2}(-\d{0,2})?)?$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    clearDates() {
      this.filter.value = {};
      this.filter.valueDescription = [];
      this.filter.dateFrom = "";
      this.filter.dateTo = "";
    },
    todayDateString() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    },
    addToISODateString(isoStringDate, duration, unit) {
      let calculatedDate = Moment(isoStringDate);
      calculatedDate.add(duration, unit)
      return calculatedDate.toISOString();
    },
    setValue(valueDescription, fromDate, toDate) {
      this.filter.valueDescription = valueDescription;
      this.filter.value = {};
      if (fromDate) {
        this.filter.value[this.filter.id.from] = new Date(fromDate).toISOString();
      }
      if (toDate) {
        this.filter.value[this.filter.id.to] = new Date(toDate).toISOString();
      }
    },
    setFilters_emit() {
      const id = this.filter.dropDownModel.id;
      const hasDateFrom = this.filter.dateFrom?.length > 0;
      const hasDateTo = this.filter.dateTo?.length > 0;
      if (id === "isOn" && hasDateFrom) {
        this.setValue(["Is on", this.filter.dateFrom],
            this.filter.dateFrom,
            this.addToISODateString(new Date(this.filter.dateFrom).toISOString(), 1, "days"));
      } else if (id === "isAfter" && hasDateFrom || id === "isInTheRange" && hasDateFrom && !hasDateTo) {
        this.setValue(["Is after", this.filter.dateFrom],
            this.filter.dateFrom,
            null);
      } else if (id === "isBefore" && hasDateTo || id === "isInTheRange" && !hasDateFrom && hasDateTo) {
        this.setValue(["Is before", this.filter.dateTo],
            null,
            this.filter.dateTo);
      } else if (id === "isInTheRange" && hasDateFrom && hasDateTo) {
        this.setValue(["Is in the range", this.filter.dateFrom, "and", this.filter.dateTo],
            this.filter.dateFrom,
            this.filter.dateTo);
      } else if (id ==="isWithin" && this.isWithinNumberModel > 0) {
        let nowISOString = new Date().toISOString();
        this.setValue(["Is within", `${this.lastUpcomingModel} ${this.isWithinNumberModel} ${this.calendricalModel}`],
            this.lastUpcomingModel === "last" ?
                this.addToISODateString(nowISOString, -this.isWithinNumberModel, this.calendricalModel) :
                nowISOString,
            this.lastUpcomingModel === "upcoming" ?
                this.addToISODateString(nowISOString, this.isWithinNumberModel, this.calendricalModel) :
                nowISOString);
      } else {
        this.setValue([], null, null);
      }

      this.filter.menuModel = false;
    },
    resetAllDateModals() {
      this.$emit("resetAllDateModals");
    },
  },
};
</script>

<style lang="scss" scoped>
.text--black input {
  color: #006ca1;
}
.date-from {
  width: 9.375em;
}
</style>
